import axiosHttp from "./interceptor.service";

const postClient = (data) => {
  return axiosHttp.post("/lmt/clientRegister", data);
};

const getClient = ({ page, limit, sort, search } = {}) => {
  return axiosHttp.get("/lmt/getClient", {
    params: { page, limit, sort, search },
  });
};

const getClientById = (id, data) => {
  return axiosHttp.get(`/lmt/getClient/${id}`, data);
};

const getClientProject = (clientId, data) => {
  return axiosHttp.get(`/lmt/showProject/${clientId}`, data);
};

const getProjectBasedClient = (id, data) => {
  return axiosHttp.get(`/lmt/getProjectBasedClient/${id}`, data);
};

const updateClient = (id, data) => {
  return axiosHttp.put(`/lmt/updateClient/${id}`, data);
};

const deleteClient = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteClient/${id}`, data);
};

const uploadSupportingDocument = (formData) => {
  return axiosHttp.post("lmt/supportingDoc", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getAllSupportingDocuments = (query) => {
  return axiosHttp.get("lmt/getAllsupportingDoc", { params: query });
};

const getSupportingDocById = (id) => {
  return axiosHttp.get(`lmt/getsupportingDocById/${id}`);
};

const updateSupportingDocument = (id, formData) => {
  return axiosHttp.put(`lmt/updateSupportingDoc/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteSupportingDocument = (id) => {
  return axiosHttp.delete(`lmt/deleteSupportingDoc/${id}`);
};

const getClientProjectReports = () => {
  return axiosHttp.get("/lmt/getClientProjectReports");
};

export {
  postClient,
  getClient,
  getClientById,
  getClientProject,
  getProjectBasedClient,
  updateClient,
  deleteClient,
  uploadSupportingDocument,
  getAllSupportingDocuments,
  updateSupportingDocument,
  deleteSupportingDocument,
  getSupportingDocById,
  getClientProjectReports,
};

